import React from 'react';
import {
  Box,
  List,
  ListItemText,
  Divider,
  Tooltip,
  ListItemIcon,
  Drawer as MuiDrawer,
  ListItemButton,
} from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import BusinessIcon from '@mui/icons-material/Business';
import PublicIcon from '@mui/icons-material/Public';
import PeopleIcon from '@mui/icons-material/People';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SettingsIcon from '@mui/icons-material/Settings';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const Drawer: React.FC<DrawerProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();

  const handleNavigate = (path: string) => {
    navigate(path);
    onClose();
  };

  const handleSignOut = () => {
    signOut();
    navigate('/login');
  };

  return (
    <MuiDrawer anchor="left" open={isOpen} onClose={onClose}>
      <Box sx={{ width: 250 }} role="presentation" onClick={onClose} onKeyDown={onClose}>
        <List>
          {user?.is_system_admin && (
            <>
              <Tooltip title="Dashboard" placement="right">
                <ListItemButton onClick={() => handleNavigate('/dashboard')}>
                  <ListItemIcon>
                    <DashboardIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText primary="Dashboard" />
                </ListItemButton>
              </Tooltip>
              <Tooltip title="Gerenciar entidades públicas." placement="right">
                <ListItemButton onClick={() => handleNavigate('/entidades-publicas')}>
                  <ListItemIcon>
                    <PublicIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText primary="Entidades Públicas" />
                </ListItemButton>
              </Tooltip>
              <Tooltip title="Gerenciar sistemas." placement="right">
                <ListItemButton onClick={() => handleNavigate('/sistemas')}>
                  <ListItemIcon>
                    <BusinessIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText primary="Sistemas" />
                </ListItemButton>
              </Tooltip>
              <Tooltip title="Gerenciar usuários." placement="right">
                <ListItemButton onClick={() => handleNavigate('/usuarios')}>
                  <ListItemIcon>
                    <PeopleIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText primary="Usuários" />
                </ListItemButton>
              </Tooltip>
              <Divider />
              <Tooltip title="Gerenciar configurações do Publisol Acta." placement="right">
                <ListItemButton onClick={() => handleNavigate('/configuracoes-publicacoes')}>
                  <ListItemIcon>
                    <NewspaperIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText primary="Configurações do Acta" />
                </ListItemButton>
              </Tooltip>
              <Tooltip title="Gerenciar publicações (Acta via Connect)." placement="right">
                <ListItemButton onClick={() => handleNavigate('/publicacoes-admin')}>
                  <ListItemIcon>
                    <NewspaperIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText primary="Publicações (Acta)" />
                </ListItemButton>
              </Tooltip>
              <Tooltip title="Gerenciar configurações do Synthesis." placement="right">
                <ListItemButton onClick={() => handleNavigate('/synthesis/configurations')}>
                  <ListItemIcon>
                    <SettingsIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText primary="Configurações Synthesis" />
                </ListItemButton>
              </Tooltip>
              <Divider />
            </>
          )}
          <Divider />
          <Tooltip title="Gerenciar perfil e informações da conta." placement="right">
            <ListItemButton onClick={() => handleNavigate('/perfil')}>
              <ListItemIcon>
                <AccountCircle color="primary" />
              </ListItemIcon>
              <ListItemText primary="Perfil" />
            </ListItemButton>
          </Tooltip>
          <Tooltip title="Desconectar sua conta Publisol." placement="right">
            <ListItemButton onClick={handleSignOut}>
              <ListItemIcon>
                <LogoutIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Desconectar" />
            </ListItemButton>
          </Tooltip>
        </List>
      </Box>
    </MuiDrawer>
  );
};

export default Drawer;